module.exports = __webpack_public_path__ + "search-compare-cover.64e48311e2afb51fc893c162187b7bd6.png";